require("./generic/lity");
require("./global/ie11");
require("./global/target-blank");
require("./global/vanilla-lazyload");
require("./modules/responsive-table");
require("./modules/location-switcher");
require("./modules/agenda");
require("./modules/calendar-card-list");
require("./modules/location");
require("./modules/references");
require("./modules/education-card-slider");
require("./modules/related-education");
require("./modules/project");
require("./modules/filter");
require("./modules/banner");
require("./modules/modal");
require("./modules/archive");
require("./modules/button");
require("./modules/route-guide");
require("./modules/accordion");
require("./modules/accordion-large");
require("./modules/header");
require("./modules/vacancy-header");
require("./modules/share");
require("./modules/hero");
require("./modules/navigation");
require("./modules/tabs");
require("./modules/slider");
require("./modules/group-slider");
require("./modules/slider-blocks");
require("./modules/slider-blocks-variant");
require("./modules/count-down-timer");
require("./vendor/mmenu");
require("./vendor/gravity-forms");

import "./components/EducationFilterer";
import "./components/PlaceholderCards";
